module.exports = __webpack_public_path__ + "img/fm-Path 44 Copy@3x.fc020be4.png";